export default {
    dashboard: {
        totalWordsGenerated: 'Total de palavras geradas',
        wordsPerDay: 'Palavras/dia',
        content: 'Conteúdo',
        date: 'Data',
        variationCount: 'Contagem de Variações',
        transactionId: 'ID da transação',
        totalWordsCount: 'Contagem Total de Palavras',
        action: 'Ação',
        goTo: 'Ir para',
        viewMore: 'Ver mais',
        showLess: 'Mostrar menos',
        tabImage: 'Imagem',
        tabText: 'Texto',
        dashboardSubtitle: 'Gerencie o conteúdo gerado pela sua IA',
        type: 'Tipo',
    },
};
